import { SendAnalytics, GenerateLabel } from "../main";

const analytics = SendAnalytics('Home Member Area')

/** 👇 View member home page */
const ViewHome = (section) => analytics({
  label: GenerateLabel({}),
  action: 'home - view home page',
  name: 'view_home',
});

/** 👇 users click nav bar home */
const ClickHome = () => analytics({
  label: GenerateLabel({}),
  action: 'home - click home',
  name: 'click_home',
});

/** 👇 users click nav bar stock pick */
const ClickCaseStudy = () => analytics({
  label: GenerateLabel({}),
  action: 'home - click stock pick',
  name: 'click_case_study',
});

/** 👇 users click nav bar updates */
const ClickUpdates = () => analytics({
  label: GenerateLabel({}),
  action: 'home - click updates',
  name: 'click_updates',
});

/** 👇 users click nav bar analysis */
const ClickAnalysis = () => analytics({
  label: GenerateLabel({}),
  action: 'home - click analysis',
  name: 'click_analysis',
});

/** 👇 users click nav bar academy */
const ClickAcademy = () => analytics({
  label: GenerateLabel({}),
  action: 'home - click academy',
  name: 'click_academy',
});

/** 👇 users click nav bar qna */
const ClickQna = () => analytics({
  label: GenerateLabel({}),
  action: 'home - click qna',
  name: 'click_qna',
});

/** 👇 users click all analysis */
const ClickAllAnalysis = () => analytics({
  label: GenerateLabel({}),
  action: 'home - click all analysis',
  name: 'click_all_analysis',
});

/** 👇 users click all updates */
const ClickAllUpdates = () => analytics({
  label: GenerateLabel({}),
  action: 'home - click all updates',
  name: 'click_all_updates',
});

/** 👇 users click all faq */
const ClickAllFaq = () => analytics({
  label: GenerateLabel({}),
  action: 'home - click all faq',
  name: 'click_all_faq',
});

/** 👇 users click halaman saham */
const ClickHalamanSaham = () => analytics({
  label: GenerateLabel({}),
  action: 'home - click halaman saham',
  name: 'click_halaman_saham',
});

/** 👇 users click notif */
const ClickNotif = () => analytics({
  label: GenerateLabel({}),
  action: 'home - click notif',
  name: 'click_notif',
});

/** 👇 users click profil */
const ClickProfile = () => analytics({
  label: GenerateLabel({}),
  action: 'home - click profil',
  name: 'click_profil',
});

/** 👇 users click event banner */
const ClickEventBanner = ({ eventName = '' }) => {
  const label = GenerateLabel({ event: eventName })
  analytics({
    label: GenerateLabel({}),
    action: 'home - click event',
    name: 'click_event_banner',
  });
};

/** 👇 users click promo banner */
const ClickPromoBanner = ({ promoName = '' }) => {
  const label = GenerateLabel({ promo: promoName })
  analytics({
    label: GenerateLabel({}),
    action: 'home - click promo',
    name: 'click_promo_banner',
  });
};

/** 👇 users click latest analysis */
const ClickLatestAnalysis = ({ contentName = '' }) => {
  const label = GenerateLabel({ content: contentName })
  analytics({
    label: GenerateLabel({}),
    action: 'home - click latest analysis',
    name: 'click_latest_analysis',
  });
};

/** 👇 users click latest updates */
const ClickLatestUpdates = ({ contentName = '' }) => {
  const label = GenerateLabel({ content: contentName })
  analytics({
    label: GenerateLabel({}),
    action: 'home - click latest updates',
    name: 'click_latest_updates',
  });
};

/** 👇  */
const ClickFaq = ({ question = '' }) => {
  const label = GenerateLabel({ faq: question })
  analytics({
    label: GenerateLabel({}),
    action: 'home - click faq', name: 'click_faq',
  });
};

/** 👇 User View Pop Up Banner Promo */
const ViewPopupPromo = ({ banner = '' }) => analytics({
  label: GenerateLabel({ banner }),
  action: 'home - view pop up promo',
  name: 'view_popup_promo',
});

/** 👇 User Click Pop Up Banner Promo */
const ClickPopupPromo = ({ banner = '' }) => analytics({
  label: GenerateLabel({ banner }),
  action: 'home - click pop up promo',
  name: 'click_popup_promo',
});

const HomePage = {
  ViewHome,
  ClickHome,
  ClickCaseStudy,
  ClickUpdates,
  ClickAnalysis,
  ClickAcademy,
  ClickQna,
  ClickAllAnalysis,
  ClickAllUpdates,
  ClickAllFaq,
  ClickHalamanSaham,
  ClickNotif,
  ClickProfile,
  ClickEventBanner,
  ClickPromoBanner,
  ClickLatestAnalysis,
  ClickLatestUpdates,
  ClickFaq,
  ViewPopupPromo,
  ClickPopupPromo,
};

export default HomePage;
